export default "__VITE_ASSET__whQA8ZFb__ 400w, __VITE_ASSET__DdPoeQ1z__ 640w, __VITE_ASSET__B6D2HiR2__ 900w";